import { useMatch } from 'react-router-dom';

export const useEnterpriseIdFromRoute = (): string | undefined =>
  useMatch('/organization/enterprise/:enterpriseOrgId/*')?.params
    .enterpriseOrgId;
